import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('form');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    changeQuestionsOrder(ctx, { id, items }) {
        return axios.$post(`/admin/forms/${id}/change-questions-order`, {
            items
        });
    },

    getSubmissions(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/forms/${id}/submissions`, {
            params
        });
    }
};
